<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="14"
    height="14"
    viewBox="0 0 14 14"
    fill="none"
  >
    <!-- Left-aligned lines + arrow to the right (reading direction). -->
    <path
      d="M2 3.25H12M2 7H8.5M2 10.75H10"
      class="stroke"
      stroke-width="1.4"
      stroke-linecap="round"
    />
    <path
      d="M9.25 5.75L11.75 7L9.25 8.25"
      class="stroke"
      stroke-width="1.4"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>

<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({
  name: "OnboardingLtrIcon",
});
</script>

<style scoped lang="scss">
@use "../icon.scss";
</style>
